import {numberFormat} from "../helpers";

export var COIN_DIVISOR: number = 100;

export function setCoinDivisor(val: number): void {
    COIN_DIVISOR = val
}

export function getCoinValue(coin: number): number {
    return coin / COIN_DIVISOR;
}

export function getCoin(coinValue: number): number {
    return coinValue * COIN_DIVISOR;
}

export function toFixed(val: number, decimals: number): string {
    return val.toFixed(decimals);
}

export function getCreditBet(atomicCreditBet: number, linesCount: number): number {
    return atomicCreditBet * linesCount;
}

export function getBet(atomicBet: number, linesCount: number): number {
    return atomicBet * linesCount;
}

export function getRealDivisor(decimals: number): number {
    return 10 ** decimals;
}

export function calcReal(val: number, decimals: number): number {
    return val / getRealDivisor(decimals);
}

export function calcCoinValues(coins: Array<number> = [], decimals: number = 2): Array<number> {
    return coins.map(coin => calcCoinValue(coin, decimals));
}

export function calcCoins(coinValues: Array<number> = []): Array<number> {
    return coinValues.map(calcCoin);
}

export function calcCoinValue(val: number, decimals: number = 2): number {
    return Number((val / COIN_DIVISOR).toFixed(decimals));
}

export function calcCoin(coinValue: number): number {
    return coinValue * COIN_DIVISOR;
}

export function getReal(val: number, decimals: number): string {
    return toFixed(calcReal(val, decimals), decimals);
}

export function getRealBet(atomicBet: number, linesCount: number, decimals: number): string {
    return toFixed(calcReal(getBet(atomicBet, linesCount), decimals), decimals);
}

export function getMoneyBet(creditBet: number, coin: number, decimals: number): number {
    return creditToMoney(creditBet, coin, decimals);
}

export function moneyToCredit(money: number, coin: number, decimals: number): number {
    return (money /coin);
}

export function moneyToCreditWithDecimals(money: number, coin: number, decimals: number): string {
    return toFixed((money /coin), decimals);
}

export function creditToMoney(credit: number, coin: number, decimals: number): number {
    return Number(toFixed(credit * getCoinValue(coin) * getRealDivisor(decimals), decimals));
}

export function moneyToReal(money: number, decimals: number): number {
    return calcReal(money, decimals);
}

export function withCurrency(value: number, currency: string, decimalPlaces: number): string {

    switch(currency) {
        case "EUR":
            return "\u20AC" + numberFormat(value, decimalPlaces, '.', ' ');
        case "USD":
            return "$" + numberFormat(value, decimalPlaces, '.', ' ');
        case "CZK":
            return numberFormat(value, decimalPlaces, '.', ' ') + " Kč";
        case "RON":
        case "LEI":
            return numberFormat(value, decimalPlaces, '.', ' ') + " Lei";
        case "PLN":
            return numberFormat(value, decimalPlaces, '.', ' ') + " PLN";
        default:
            return numberFormat(value, decimalPlaces, '.', ' ') + " " + currency;
    }
}

export function isBetAllowed(atomicBet: number, betset = []): boolean {
    return betset.indexOf(atomicBet) > -1;
}

export function calcMaxBet(
    balance: number,
    decimals: number,
    lines: Array<number>,
    creditBets: Array<number>,
    coinValues: Array<number>,
    betset: Array<number>
): {linesCount: number, creditBet: number, coinValue: number} {

    let defLine = lines[0];
    let defBet = creditBets[0];
    let defCoin = coinValues[0];
    let res = { linesCount: defLine, creditBet: defBet, coinValue: defCoin };

    let maxBetSet = lines[lines.length-1] * creditBets[creditBets.length-1] * (10 ** decimals) * coinValues[coinValues.length -1];
    let maxBetsetBalance = getMaxBetsetBalance(balance, maxBetSet, betset, lines);

    for(let l = lines.length; l--;) {
        for(let b = creditBets.length; b--;) {
            for(let d = coinValues.length; d--;) {

                let maxbet = lines[l] * getMoneyBet(creditBets[b], getCoin(coinValues[d]), decimals);
                if(maxbet == maxBetsetBalance) {
                    res.linesCount = lines[l];
                    res.creditBet = creditBets[b];
                    res.coinValue = coinValues[d];

                    return res;
                }
            }
        }
    }

    return res;
}

function getMaxBetsetBalance(balance: number, maxBetSet: number, betset: Array<number>, lines: Array<number>): number {

    let bal = balance;
    for(let l of lines) {
        for (let bs of betset) {
            bs *= l;
            if (bs > balance) {
                break;
            }

            bal = bs;
        }
    }

    return Math.min(bal, maxBetSet);
}
